(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('followup-status', {
            parent: 'entity',
            url: '/followup-status?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.followupStatus.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/followup-status/followup-statuses.html',
                    controller: 'FollowupStatusController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('followupStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('followup-status-detail', {
            parent: 'entity',
            url: '/followup-status/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.followupStatus.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/followup-status/followup-status-detail.html',
                    controller: 'FollowupStatusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('followupStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'FollowupStatus', function($stateParams, FollowupStatus) {
                    return FollowupStatus.get({id : $stateParams.id});
                }]
            }
        })
        .state('followup-status.new', {
            parent: 'followup-status',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/followup-status/followup-status-dialog.html',
                    controller: 'FollowupStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('followup-status', null, { reload: true });
                }, function() {
                    $state.go('followup-status');
                });
            }]
        })
        .state('followup-status.edit', {
            parent: 'followup-status',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/followup-status/followup-status-dialog.html',
                    controller: 'FollowupStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FollowupStatus', function(FollowupStatus) {
                            return FollowupStatus.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('followup-status', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('followup-status.delete', {
            parent: 'followup-status',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/followup-status/followup-status-delete-dialog.html',
                    controller: 'FollowupStatusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['FollowupStatus', function(FollowupStatus) {
                            return FollowupStatus.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('followup-status', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
